import { render } from "./EditSong.vue?vue&type=template&id=f0f1dd36"
import script from "./EditSong.vue?vue&type=script&lang=js"
export * from "./EditSong.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__